// extracted by mini-css-extract-plugin
export default {"rockets-container":"RocketsView_rockets-container__6RFA0","rockets-list":"RocketsView_rockets-list__VcITn","loader":"RocketsView_loader__+uO59"};